import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import ContactForm from "../../components/ContactForm/ContactForm";

const Contact = () => {
    const { t } = useTranslation();

    return (
        <main className='main contact-page'>

            <Breadcrumb title={t('nav.contact')}/>

            <ContactForm/>
        </main>
    );
};

export default Contact;
